function preloader() {
    setTimeout(function() {
        $('html, body').css('overflow-y', 'visible');
        $('.async-preloader').css('opacity', '0');
        setTimeout(function() {
            $('.async-preloader').hide();
        }, 300);
    }, 800);
}

$(document).ready(function() {

    preloader();

    setTimeout(function() {
        let mId_init = $('#main-slider .owl-item.active .main-item').data('main-id');
        $(`.vertical-thumbnail .thumbnail[data-vertical-id="${mId_init}"]`).addClass('active').siblings().removeClass('active');
        
        $(`#option-slider .option-item[data-media-id="${mId_init}"]`).addClass('active');
    }, 50);
    
    let sync1 = $("#main-slider");
    let sync2 = $("#option-slider");
    let syncedSecondary = true;

    sync1.owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: false,
        autoplay: false,
        dots: false,
        loop: true,
        margin: 15,
        responsiveRefreshRate: 200,
    }).on('changed.owl.carousel', syncPosition);

    sync2.on('initialized.owl.carousel', function () {
        sync2.find(".owl-item").eq(0).addClass("current");
    })
    .owlCarousel({
        items: 3,
        nav: false,
        margin: 15,
        smartSpeed: 200,
        slideSpeed: 500,
        slideBy: 5,
        responsiveRefreshRate: 100,
        responsive: {
            0: {
                items: 3,
                slideBy: 3,
            },
            768: {
                items: 4,
                slideBy: 4,
            },
            1280: {
                items: 20,
                slideBy: 20,
            },
        }
    }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }

        sync2.find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }

        setTimeout(function() {
            let mId = $('#main-slider .owl-item.active .main-item').data('main-id');
            $(`.vertical-thumbnail .thumbnail[data-vertical-id="${mId}"]`).addClass('active').siblings().removeClass('active');
            
            $('#option-slider .option-item').removeClass('active');
            $(`#option-slider .option-item[data-media-id="${mId}"]`).addClass('active');
        }, 50);

        var $container = $(".vertical-thumbnail");
        var $activeThumbnail = $container.find(".thumbnail.active");

        if ($activeThumbnail.length) {
            setTimeout(function() {
                $container.scrollTop($activeThumbnail.offset().top - $container.offset().top);
            }, 50);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });

    $('.thumbnail').on('click', function() {
        $(this).addClass('active').siblings().removeClass('active');

        let vId = $(this).data('vertical-id');

        $(`#option-slider .option-item[data-media-id="${vId}"]`).trigger('click');
    });

    var isDragging = false;
    var initialMouseY = 0;
    var initialScrollTop = 0;

    var $scrollableContainers = $(".vertical-thumbnail");

    $scrollableContainers.on("mousedown", function(event) {
        isDragging = true;
        initialMouseY = event.clientY;
        initialScrollTop = $(this).scrollTop();
        $(this).css("cursor", "grabbing");
    });

    $(document).on("mouseup", function() {
        isDragging = false;
        $(".vertical-thumbnail").css("cursor", "grab");
    });

    $(document).on("mousemove", function(event) {
        if (!isDragging) return;
        var deltaY = event.clientY - initialMouseY;
        $scrollableContainers.each(function() {
        $(this).scrollTop(initialScrollTop - deltaY);
        });
    });

});